module.exports = __webpack_public_path__ + "static/media/golf-ball.570599de.ico";